import e from "react";
import t from "@appchoose/cn";
import a from "@appchoose/icon";
import * as o from "@radix-ui/react-switch";
const i = e.forwardRef(({ className: r, ...s }, c) => /* @__PURE__ */ e.createElement(
  o.Root,
  {
    className: t(
      "relative inline-flex h-7 w-10 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-300 transition-colors duration-100 ease-in-out focus:outline focus:outline-gray-400/20 disabled:cursor-not-allowed disabled:bg-gray-50 data-[state=checked]:bg-green-900 data-[state=checked]:focus:outline-green-900/20 data-[state=checked]:disabled:bg-gray-100",
      r
    ),
    ...s,
    ref: c
  },
  /* @__PURE__ */ e.createElement(
    o.Thumb,
    {
      className: t(
        "group pointer-events-none inline-block size-6 rounded-full bg-white text-gray-300 shadow-sm ring-0 transition duration-100 ease-in-out data-[state=checked]:translate-x-3 data-[state=unchecked]:translate-x-0 data-[disabled]:text-gray-100 data-[state=checked]:text-green-900"
      )
    },
    /* @__PURE__ */ e.createElement(
      a,
      {
        icon: "check",
        size: "medium",
        className: t(
          "absolute left-1 top-1 hidden group-data-[state=checked]:block"
        )
      }
    ),
    /* @__PURE__ */ e.createElement(
      a,
      {
        icon: "close",
        size: "medium",
        className: t(
          "absolute left-1 top-1 hidden group-data-[state=unchecked]:block"
        )
      }
    )
  )
));
i.displayName = "ToggleSwitch";
export {
  i as default
};
